/**
 * Grid classname
 */
export var GRID_BASE_CLASSNAME = 'ws10-grid';
/**
 * Class that is applied when optVerticalGutter=false
 */
export var GRID_NO_VERTICAL_CUTTER_CLASSNAME = "".concat(GRID_BASE_CLASSNAME, "--no-vertical-gutter");
